module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125128.408bc26f.jpg";